<div class="card-details-container">
  <lib-progress-bar-card
    class="wide-card"
    [title]="'DASHBOARD.ASSET_BREAKDOWN.ASSET_ANALYSIS'"
    [number]="getAssetSum()"
    [countIncrease]="customersData.countIncrease"
    [percentage]="customersData.increasePercentage"
    [wide]="true"
    [categories]="assetAnalysisCategories"
    [wide]="true"
  ></lib-progress-bar-card>
  <lib-progress-bar-card
    [title]="'MAIN_SIDEBAR.CUSTOMERS'"
    [number]="customersData.totalCount"
    [countIncrease]="customersData.countIncrease"
    [percentage]="customersData.increasePercentage"
    [seeBreakdownVisible]="true"
    (detailsClicked)="openDetailsModal('customer')"
    [categories]="customerCategories"
  ></lib-progress-bar-card>
  <lib-progress-bar-card
    [title]="'AI.BUILDINGS'"
    [number]="buildingsData.totalCount"
    [countIncrease]="buildingsData.countIncrease"
    [percentage]="buildingsData.increasePercentage"
    [categories]="buildingCategories"
  ></lib-progress-bar-card>
  <lib-progress-bar-card
    [title]="'ADVANCED_MAP.LEGEND.POLES'"
    [number]="poleSum"
    [seeBreakdownVisible]="true"
    (detailsClicked)="openDetailsModal('pole')"
    [countIncrease]="poleData.countIncrease"
    [percentage]="poleData.increasePercentage"
    [categories]="poleCategories"
  ></lib-progress-bar-card>
  <lib-progress-bar-card
    [title]="'DATA_MODEL_CUSTOMIZATION.CATEGORIES.NETWORK_STRUCTURE'"
    [number]="networkStructureData.totalCount"
    [countIncrease]="networkStructureData.countIncrease"
    [percentage]="networkStructureData.increasePercentage"
    (detailsClicked)="openDetailsModal('network structure')"
    [seeBreakdownVisible]="true"
    [categories]="networkStructureCategories"
  ></lib-progress-bar-card>
  <lib-progress-bar-card
    [title]="'AI.FEEDERS'"
    [number]="feedersOverviewData.totalCount"
    [countIncrease]="feedersOverviewData.countIncrease"
    [percentage]="feedersOverviewData.increasePercentage"
    [categories]="feederCategories"
  ></lib-progress-bar-card>
  <lib-progress-bar-card
    [title]="'AI.DEVICES'"
    [number]="devicesOverviewData.totalCount"
    [countIncrease]="devicesOverviewData.countIncrease"
    [percentage]="devicesOverviewData.increasePercentage"
    [categories]="deviceCategories"
  ></lib-progress-bar-card>
</div>

<lib-breakdown-dialog
  [totalCount]="customersData.totalCount"
  [categories]="customerCategories"
  [breakdownData]="customerBreakdownData"
  (closed)="onCloseDetailsModal()"
  [mainTitle]="'DASHBOARD.OPERATIONS_ANALYTICS.CUSTOMERS_COUNT'"
  *ngIf="selectedDetailsType == 'customer'"
>
</lib-breakdown-dialog>

<lib-breakdown-dialog
  [totalCount]="networkStructureData.totalCount"
  [categories]="networkStructureCategories"
  [breakdownData]="networkStructureBreakdownData"
  (closed)="onCloseDetailsModal()"
  [mainTitle]="'Network Structure Count'"
  *ngIf="selectedDetailsType == 'network structure'"
>
</lib-breakdown-dialog>

<lib-breakdown-dialog
  [totalCount]="poleSum"
  [categories]="poleCategories"
  [breakdownData]="poleBreakdownData"
  (closed)="onCloseDetailsModal()"
  [mainTitle]="'DASHBOARD.OPERATIONS_ANALYTICS.POLES_COUNT'"
  *ngIf="selectedDetailsType == 'pole'"
>
</lib-breakdown-dialog>
